export { default as ExchangeRatesListTooltipIconButton } from './ExchangeRatesListTooltipIconButton';
